import { api } from "assets/scripts/utilities/api-clients";

export const drop = async (note) => {
  const response = await api.delete(`kam/notes/${note._id}`);

  return response;
};

export const index = async (options = {}) => {
  const response = await api.get("kam/notes", options);

  return response;
};

export const get = async (id) => {
  const response = await api.get(`kam/notes/${id}`, {
    responseType: "blob",
  });

  return response;
};

export const post = async (note) => {
  const response = await api.post("kam/notes", note);

  return response;
};

export const put = async (note) => {
  const response = await api.put("kam/notes", note);

  return response;
};
